'use client';

import { __assign } from '../../_virtual/_tslib.js';
import { EApplyType } from '../../services/resumes/types.js';
import { EFormFieldIDs } from '../constants.js';

var initialState = {
    resumeInfo: null,
    workingPreference: null,
    applicationInformation: null,
    collapsiblesControl: new Set([
        EFormFieldIDs.yourResume,
        EFormFieldIDs.coverLetter,
        EFormFieldIDs.applicationInfomation,
        EFormFieldIDs.workingPreferences
    ]),
    errorsControl: [],
    submitControl: [],
    applyResume: {
        resumeId: -1,
        type: EApplyType.none
    },
    justUploadedResumeId: -1,
    isSumitted: false
};
function reducer(state, action) {
    switch (action.type) {
        case 'setResumeSettingInfo':
            return __assign(__assign({}, state), { resumeInfo: action.payload });
        case 'setSelectResume':
            return __assign(__assign({}, state), { applyResume: action.payload });
        case 'setApplicationInformation':
            return __assign(__assign({}, state), { applicationInformation: action.payload });
        case 'setWorkingPreference':
            return __assign(__assign({}, state), { workingPreference: action.payload });
        case 'addCollapsibleControl': {
            var collapsibleControlValues_1 = state.collapsiblesControl;
            if (Array.isArray(action.payload)) {
                var filtedCollapsibleControlValues = action.payload.filter(function (item) { return !collapsibleControlValues_1.has(item); });
                if (filtedCollapsibleControlValues.length > 0) {
                    filtedCollapsibleControlValues.forEach(collapsibleControlValues_1.add, collapsibleControlValues_1);
                }
            }
            else {
                if (!state.collapsiblesControl.has(action.payload)) {
                    collapsibleControlValues_1.add(action.payload);
                }
            }
            return __assign(__assign({}, state), { collapsiblesControl: collapsibleControlValues_1 });
        }
        case 'setCollapsibleControl': {
            var collapsibleControlValues = state.collapsiblesControl;
            if (state.collapsiblesControl.has(action.payload)) {
                collapsibleControlValues.delete(action.payload);
            }
            else {
                collapsibleControlValues.add(action.payload);
            }
            return __assign(__assign({}, state), { collapsiblesControl: collapsibleControlValues });
        }
        case 'addErrorsControl': {
            var errorsControlValues = state.errorsControl;
            errorsControlValues.push(action.payload);
            return __assign(__assign({}, state), { errorsControl: errorsControlValues });
        }
        case 'removeErrorsControl': {
            var errorsControlValues = state.errorsControl.filter(function (item) { return item !== action.payload; });
            return __assign(__assign({}, state), { errorsControl: errorsControlValues });
        }
        case 'setResumeInfo': {
            return __assign(__assign({}, state), { resumeInfo: action.payload });
        }
        case 'setApplyResume': {
            return __assign(__assign({}, state), { applyResume: action.payload });
        }
        case 'setJustUploadedResumeId': {
            return __assign(__assign({}, state), { justUploadedResumeId: action.payload });
        }
        case 'addSubmitControl': {
            var submitControlValues = state.submitControl;
            submitControlValues.push(action.payload);
            return __assign(__assign({}, state), { submitControl: submitControlValues });
        }
        case 'deleteSubmitControl': {
            return __assign(__assign({}, state), { submitControl: [] });
        }
        case 'setSumitted': {
            return __assign(__assign({}, state), { isSumitted: action.payload });
        }
        default:
            return state;
    }
}

export { reducer as default, initialState };
//# sourceMappingURL=reducer.js.map
